import checkIcon from '@r1-frontend/ui-react/assets/img/check-green.svg';
import Button from '@r1-frontend/ui-react/components/buttons/button';
import { SingleArrowDown } from '@r1-frontend/ui-react/components/svg/arrows';
import { BoxShadow } from '@r1-frontend/ui-react/tokens/boxShadow';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import React from 'react';
import { components } from 'react-select';
import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-16px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

/**
 * Добавочный элемент. Костыль для устранения обрезки тени, когда у родительского компонента overflow: hidden
 * Добавляется невидимый элемент под тенью списка, подымая край тени чуть выше
 */
const getBottomElement = () => {
  return css`
    &::after {
      content: "";
      position: absolute;
      bottom: -25px;
      width: 100%;
      height: 1px;
      background-color: transparent;
      z-index: 1;
    }
  `;
};

export const StyledMenu = styled(components.Menu)`
  position: absolute;
  margin: 0 !important;
  top: calc(100% + 10px) !important;
  left: 0;
  box-shadow: ${BoxShadow.M} !important;
  border-radius: 16px !important;
  animation: ${fadeIn} 0.2s ease-in-out;
  z-index: 10000 !important;

  ${p => p.selectProps?.addBottomElement && getBottomElement()};
`;

export const Menu = (props) => {
    const { children, ...rest } = props;

    return (
        <StyledMenu data-test='select-menu' {...rest}>
            {children}
        </StyledMenu>
    );
};

const BtnWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px 30px 16px 20px;
`;

const MenuListStyled = styled.div`
  width: 100%;
  border-radius: 16px;
  padding: 0;
  max-height: ${(props) => {
    if (!props.maxHeight) {
      return '300px';
    }
    return props.maxHeight + 'px';
  }};
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
`;

export const MenuList = (props) => {
    const { children, innerRef, selectProps: { btnProps, maxHeight } } = props;

    return (
        <MenuListStyled
            data-test='select-menuList'
            ref={innerRef}
            maxHeight={maxHeight}
        >
          {children}
          {!!btnProps &&
            <BtnWrapper>
              <Button
                  bType='secondary'
                  size='small'
                  onClick={btnProps.onClick}
                  disabled={btnProps.isDisable}
              >
                  {btnProps.btnText}
              </Button>
            </BtnWrapper>
          }
        </MenuListStyled>
    );
};

const StyledOption = styled.div`
  width: 100%;
  min-height: ${props => props.smallOption ? '36px' : '48px'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${COLORS.BgMain};
  ${FONTS.XS};
  color: ${COLORS.TextPrimary};
  padding: 8px 30px 8px 20px;
  transition: background-color linear .2s;
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: ${COLORS.BgSecondary};
  }
`;

const StyledOptionSmall = styled.div`
  width: 100%;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${COLORS.BgMain};
  ${FONTS.XS};
  color: ${COLORS.TextPrimary};
  padding: 6px 20px 6px 10px;
  transition: background-color linear .2s;
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: ${COLORS.BgSecondary};
  }

  @media (max-width: 1000px) {
    min-height: 28px;
    padding: 4px 20px 4px 10px;
  }
`;

const StyledIcon = styled.img`
  width: 20px;
  position: absolute;
  right: 16px;
`;

const StyledOptionLinked = styled.a`
  text-decoration: none;
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${COLORS.BgMain};
  ${FONTS.XS};
  color: ${COLORS.TextPrimary};
  padding: 8px 30px 8px 20px;
  transition: background-color linear .2s;
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: ${COLORS.BgSecondary};
  }
`;

export const OptionLinked = (props) => {
  const {
      children,
      isDisabled,
      isFocused,
      isSelected,
      innerRef,
      innerProps,
  } = props;
  const path = props.data.path ? props.data.path : './';
  return (
      <StyledOptionLinked href={path}
          ref={innerRef}
          isFocused={isFocused}
          isSelected={isSelected}
          isDisabled={isDisabled}
          {...innerProps}>
          {children}
          {isSelected && <StyledIcon src={checkIcon} alt='check'/>}
      </StyledOptionLinked>
  );
};

export const Option = (props) => {
    const {
        children,
        isDisabled,
        isFocused,
        isSelected,
        innerRef,
        innerProps,
        smallOption,
    } = props;
    return (
        <StyledOption
            smallOption={smallOption}
            ref={innerRef}
            isFocused={isFocused}
            isSelected={isSelected}
            isDisabled={isDisabled}
            {...innerProps}>
            {children}
            {isSelected && <StyledIcon src={checkIcon} alt='check'/>}
        </StyledOption>
    );
};

export const SmallOption = (props) => {
    const {
        children,
        isDisabled,
        isFocused,
        isSelected,
        innerRef,
        innerProps,
    } = props;
    return (
        <StyledOptionSmall ref={innerRef}
                           isFocused={isFocused}
                           isSelected={isSelected}
                           isDisabled={isDisabled} {...innerProps}>
            {children}
            {isSelected && <StyledIcon src={checkIcon} alt='check'/>}
        </StyledOptionSmall>
    );
};

const ControlDiv = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 100px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${FONTS.XS};

  border: 2px solid ${props => {
    if (props.menuIsOpen) {
      return COLORS.Control;
    }

    return props.isFocused ? COLORS.GRAY_LIGHT : COLORS.BgSecondary;
  }};
  
  border-radius: 16px;
  transition: border-color linear .1s;
  
  background-color: ${(props) => {
    if (props.isDisabled) {
      return COLORS.BgSecondary;
    }

    return COLORS.BgMain;
  }};

  cursor: pointer;
  transition: all 0.2s linear;

  &:hover {
    border-color: ${props => props.menuIsOpen ? COLORS.GRAY_DARK : COLORS.GRAY_LIGHT};
  }
`;

export const Control = ({ innerRef, innerProps, ...rest }) => {
    delete rest['cx'];
    return <ControlDiv ref={innerRef} {...innerProps} {...rest}/>;
};

export const Container = styled.div`
  width: ${props => props.width || '100%'};
  display: block;

  ${props => !props.isSearchable && css`
    input {
      user-select: none;
    }
  `}
`;

const Icon = styled.span`
  background: url("${({ path }) => path}") 50% 50% no-repeat;
  width: ${({ size = 0 }) => size}px;
  height: ${({ size = 0 }) => size}px;

  ${props => props.isOpen && css`transform: rotate(180deg); transition: 0.30s;`}
`;

const IconWrap = styled.div`
  width: ${({ size = 24 }) => size}px;
  height: ${({ size = 24 }) => size}px;

  ${props => props.isOpen && css`transform: rotate(180deg); transition: 0.30s;`}
`;

const Indicator = styled(components.DropdownIndicator)`
  width: 17px;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  padding: 0 !important;
`;

const Clear = styled(components.ClearIndicator)`
  width: 17px;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  padding: 0 !important;
`;

export const DropdownIndicator = props => {
  const isOpen = props?.selectProps?.menuIsOpen;

  return (
    <Indicator {...props}>
      <IconWrap isOpen={isOpen}>
        <SingleArrowDown/>
      </IconWrap>
    </Indicator>
  );
};

export const ClearIndicator = props => {
  const isOpen = props?.selectProps?.menuIsOpen;
  const color = isOpen ? COLORS.TextWhite : COLORS.TextPrimary;
  return (
    <Clear {...props}>
      <Icon
        size='14'
        path={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 26' style='fill:none;stroke:%23${color.slice(1, 7)};stroke-linecap:round;'%3E%3Cpath d='M1 1l24 24M25 1L1 25'/%3E%3C/svg%3E`}
        isOpen={isOpen}
      />
    </Clear>
  );
};

export const customStyles = {
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 16px',
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    font: 'var(--regular-xs)',
    color: COLORS.TextDisabled,
    textAlign: 'left',
    padding: '8px 30px 8px 20px',
  }),
  loadingMessage: (provided) => ({
      ...provided,
      font: 'var(--regular-xs)',
      color: COLORS.TextDisabled,
  }),
  placeholder: (provided) => ({
      ...provided,
      color: COLORS.TextDisabled,
  }),
  input: (provided) => ({
    ...provided,
    color: COLORS.TextPrimary,
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.selectProps.menuIsOpen ? COLORS.TextWhite : COLORS.TextPrimary,
  }),
};
